import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import checkIcon from 'components/asset/UnChecked.svg';

export const useSelectedManagerColumnDefs = () => {
  const { t } = useTranslation();
  const sDefaultColDef = useMemo((): ColDef => {
    return {
      sortable: false,
      resizable: true,
      cellStyle: { textAlign: 'center' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  const sColDefs = useMemo((): any[] => {
    return [
      {
        headerName: 'check',
        headerComponentParams: {
          template: `<img src=${checkIcon} alt=''/>`,
        },
        width: '28px',
        height: 24,
        padding: '2px 6px',
        resizable: false,
        headerCheckboxSelection: true,
        showDisabledCheckboxes: true,
        checkboxSelection: true,
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          width: '28px',
          height: 24,
        },
      },
      {
        headerName: t('com.label.00012', '__이름'),
        field: 'empNm',
        tooltipField: 'empNm',
        flex: 1,
      },
      {
        headerName: t('com.label.00090', '__이메일'),
        field: 'emlSvrDmnIfoNm',
        tooltipField: 'emlSvrDmnIfoNm',
        cellStyle: { textAlign: 'left' },
        flex: 1,
      },
    ];
  }, []);

  return { sDefaultColDef, sColDefs };
};
